<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="add-affcompany" animation="fadeInRight">
      <div slot="title">Add Affiliate Company</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Company Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addAffCompany['name']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">URL</div>
            <div class="col-lg-9">
              <input type="url" name="" class="form-control" v-model="addAffCompany['url']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Username</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addAffCompany['username']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Password</div>
            <div class="col-lg-9">
              <input type="password" name="" class="form-control" v-model="addAffCompany['password']">
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveAffiliateCompany">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Affiliate Companies</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-affcompany">Add Affiliate Company</button>
      </div>
      <div class="ibox-content col-lg-12">
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import List from './AffiliateCompanies/List'
import axios from 'axios'
import { AFFILIATE_COMPANIES_SET } from '../../../store/mutation-types'
import Modal from '../../Helpers/Modal/Form'

const companyAddDefaults = {
  name: '',
  url: '',
  username: '',
  password: ''
}

export default {
  data () {
    return {
      addAffCompany: {...companyAddDefaults}
    }
  },
  mounted () {
    document.title = 'Affiliate Companies :: PBN360 by Aphex Media'
  },
  components: {
    list: List,
    modalForm: Modal
  },
  methods: {
    async saveAffiliateCompany () {
      try {
        const addAffCompany = {...this.addAffCompany}
        if (!addAffCompany.name) {
          this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
          return
        }
        let resp = await axios.post('/advertisers/affiliate-companies', addAffCompany)
        $('#add-affcompany').modal('hide')
        this.$store.commit(AFFILIATE_COMPANIES_SET, [...this.$store.state.affiliateCompanies, resp.data])
        this.$toastr.success('Affiliate Company added successfully', 'Brilliant stuff lad')
      } catch (e) {
        const msg = e.response ? e.response.data.msg : 'Not so great is it...'
        this.$toastr.error(e, msg)
      }
      // Reset form to defaults
      Object.keys(companyAddDefaults).forEach(k => {
        this.$set(this.addAffCompany, k, companyAddDefaults[k])
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/AffiliateCompanies.vue